import { API_CONFIG, getAuthHeader } from '../config';

export interface Demande {
  id: number;
  id_voyageur: number;
  titre: string;
  etat_visa: string;
  etat_paiement: string;
  prixconsulat: number;
  prixintervention: number;
  date_creation: string;
  datedepart: string;
  infosdemande: string;
  alerte: string;
  nom: string;
  prenom: string;
  telephone: string;
  email: string;
  options: string;
  assurancevisa: string;
  commentaires: string;
  commentairesvisa: string;
  chemin: string;
  datevalidite: string | null;
  dateexpiration: string | null;
  infosvisa: string;
  urlvoyageur?: string;
}

export interface Statistiques {
  demandesJour: number;
  aTraiter: number;
  enCours: number;
  traitees: number;
  total: number;
  parMois: Array<{
    mois: string;
    count: number;
  }>;
}

export interface BonCommande {
  id: number;
  date_emission: string;
  date_paiement: string | null;
  total: number;
  etat: string;
  nom: string;
  envoie_facture: string;
  urlfacture: string;
  numfacture: string;
  email: string;
  demande_ids: string;
}

class DemandesLegrandService {
  // Récupérer toutes les demandes
  async getDemandes(): Promise<Demande[]> {
    const response = await fetch(`${API_CONFIG.baseUrl}/api/legrand/demandes`, {
      headers: getAuthHeader('legrand'),
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la récupération des demandes');
    }

    return response.json();
  }

  // Récupérer une demande spécifique
  async getDemandeById(id: number): Promise<Demande> {
    const response = await fetch(`${API_CONFIG.baseUrl}/api/legrand/demandes/${id}`, {
      headers: getAuthHeader('legrand'),
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la récupération de la demande');
    }

    return response.json();
  }

  // Mettre à jour le statut d'une demande
  async updateDemandeStatus(id: number, data: {
    etat_visa?: string;
    etat_paiement?: string;
    infosdemande?: string;
    alerte?: string;
  }): Promise<void> {
    const response = await fetch(`${API_CONFIG.baseUrl}/api/legrand/demandes/${id}/status`, {
      method: 'PUT',
      headers: {
        ...getAuthHeader('legrand'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la mise à jour du statut');
    }
  }

  // Mettre à jour les commentaires
  async updateCommentaires(id: number, data: {
    commentaires?: string;
    commentairesvisa?: string;
  }): Promise<void> {
    const response = await fetch(`${API_CONFIG.baseUrl}/api/legrand/demandes/${id}/commentaires`, {
      method: 'PUT',
      headers: {
        ...getAuthHeader('legrand'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la mise à jour des commentaires');
    }
  }

  // Récupérer les statistiques
  async getStatistiques(): Promise<Statistiques> {
    const response = await fetch(`${API_CONFIG.baseUrl}/api/legrand/statistiques`, {
      headers: getAuthHeader('legrand'),
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la récupération des statistiques');
    }

    return response.json();
  }

  // Récupérer les bons de commande
  async getBonsCommande(): Promise<BonCommande[]> {
    const response = await fetch(`${API_CONFIG.baseUrl}/api/legrand/bons-commande`, {
      headers: getAuthHeader('legrand'),
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la récupération des bons de commande');
    }

    return response.json();
  }
}

export const demandesLegrandService = new DemandesLegrandService();